module.exports = __webpack_public_path__ + "img/starname-dark.714590bf.svg";